import React from 'react';
import { STAGES_CONFIG } from '../constants/crmConstants';

const StudentCard = ({ student, onClick }) => {
  const config = STAGES_CONFIG[student.stage];

  return (
    <div 
      onClick={() => onClick(student)}
      className="group relative bg-white p-3 rounded-xl shadow-sm border border-slate-100 hover:border-blue-200 hover:shadow-md transition-all cursor-pointer overflow-hidden"
    >
      {/* Visual Accent Line */}
      <div 
        className="absolute top-0 left-0 w-1 h-full" 
        style={{ backgroundColor: config.color }}
      />
      
      <div className="flex justify-between items-start">
        <div className="flex-1 min-w-0 pr-2">
          <h4 className="font-bold text-slate-800 group-hover:text-blue-600 transition-colors truncate text-[13px] leading-tight">
            {student.name}
          </h4>
          <p className="text-[10px] text-slate-400 font-medium truncate mt-0.5 uppercase tracking-tight">
            {student.destinationUniversity || 'University TBD'}
          </p>
          
          {/* Standardized TWG Program Tag */}
          <div className="mt-2">
            <span className="inline-block text-[9px] font-black text-[#0464AD] bg-blue-50 px-1.5 py-0.5 rounded uppercase tracking-wider">
              {student.twgProgram || 'Program TBD'}
            </span>
          </div>
        </div>
        <div className="text-sm opacity-20 group-hover:opacity-100 transition-opacity">
          {config.icon}
        </div>
      </div>
    </div>
  );
};

export default StudentCard;